import {
  ChangeDetectionStrategy,
  Component,
  input,
  output,
  ViewEncapsulation,
} from '@angular/core';
import { TranslateModule } from '@ngx-translate/core';
import { IconsModule, WuiButtonModule, WuiMenuModule } from 'wflow-ui';
import { PeppolDetailEvent } from '../../../../interfaces/peppol-detail.interface';
import {
  PeppolAction,
  PeppolActionConfig,
} from '../../../../interfaces/peppol-action.interface';
import { PeppolStatusCardComponent } from '../../../peppol-status-card/peppol-status-card.component';

@Component({
  selector: 'wf-peppol-detail-status',
  changeDetection: ChangeDetectionStrategy.OnPush,
  encapsulation: ViewEncapsulation.None,
  imports: [
    TranslateModule,
    IconsModule,
    WuiButtonModule,
    WuiMenuModule,
    PeppolStatusCardComponent,
  ],
  templateUrl: './peppol-detail-status.component.html',
  styleUrl: './peppol-detail-status.component.scss',
  host: { class: 'wf-peppol-detail-status' },
})
export class PeppolDetailStatusComponent {
  readonly event = input.required<PeppolDetailEvent>();
  readonly actions = input<PeppolActionConfig[]>([]);

  readonly actionSelected = output<PeppolAction>();
}
